
import { Component, Vue, Prop } from 'vue-property-decorator'
import { setProductInfo } from '@/api/product/product'
import { Form as ElForm } from 'element-ui'
import { AppModule } from '@/store/modules/app'
import {
  getAccountStatistic,
  getProductInfo
} from '@/api/product/productAccount'

@Component({
  name: 'usdtExtra',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) private product!: any

  private extraParam: any = {
    api_key: [],
    collect_key: [],
    reuse_address: false,
    collect_by_stake: false,
    show_paid_button: [],
    not_display_wallet_app: [],
    not_display_visa_payment: [],
    not_display_qrcode: [],
    transit_payment: [],
    transit_choice: [],
    not_reuse_address: [],
    reuse_address_days: '',
    use_upstream_api: 0
  }
  private reuseAddress: boolean = false
  private collectStake: boolean = false
  private reuseAddressDays: any = '60'

  private reuseAddressCount: any = null

  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  private back() {
    this.$emit('close', false)
  }

  // api key
  private addCmApiKey() {
    this.extraParam.api_key.push('')
  }
  private removeCmApiKey(index: number) {
    this.extraParam.api_key.splice(index, 1)
  }
  private async noExtraUpdate() {
    // 清空未输入
    this.extraParam.api_key = this.extraParam.api_key.filter(
      item => item !== ''
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        api_key: this.extraParam.api_key
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // collect key
  private addCmCollectKey() {
    this.extraParam.collect_key.push('')
  }
  private removeCmCollectKey(index: number) {
    this.extraParam.collect_key.splice(index, 1)
  }
  private async noExtraCollectUpdate() {
    // 清空未输入
    this.extraParam.collect_key = this.extraParam.collect_key.filter(
      item => item !== ''
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        collect_key: this.extraParam.collect_key
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // Reuse Deposit Address
  private async noReuseAddress() {
    try {
      this.flag = true
      const data: any = {
        id: this.product.id,
        extra_param: {
          reuse_address: this.extraParam.reuse_address,
          reuse_address_days: this.extraParam.reuse_address_days
        }
      }
      await setProductInfo(data).then(() => {
        this.$message({
          message: 'Edit success',
          type: 'success'
        })
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // Not Reuse Deposit Address
  private addCmReuseAddress() {
    this.extraParam.not_reuse_address.push('')
  }
  private removeCmReuseAddress(index: any) {
    this.extraParam.not_reuse_address.splice(index, 1)
  }
  private async noNotReuseAddress() {
    try {
      // 清空未输入
      this.extraParam.not_reuse_address =
        this.extraParam.not_reuse_address.filter(item => item !== '')
      this.flag = true
      const data: any = {
        id: this.product.id,
        extra_param: {
          not_reuse_address: this.extraParam.not_reuse_address
        }
      }
      await setProductInfo(data).then(() => {
        this.$message({
          message: 'Edit success',
          type: 'success'
        })
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // Collect By Stake
  private async noCollectStake() {
    try {
      this.flag = true
      const data: any = {
        id: this.product.id,
        extra_param: {
          collect_by_stake: this.extraParam.collect_by_stake
        }
      }
      await setProductInfo(data).then(() => {
        this.$message({
          message: 'Edit success',
          type: 'success'
        })
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // Show Paid Button
  private addCmPaidBtm() {
    this.extraParam.show_paid_button.push('')
  }
  private removeCmPaidBtm(index: number) {
    this.extraParam.show_paid_button.splice(index, 1)
  }
  private async noProductPaidBtm() {
    // 清空未输入
    this.extraParam.show_paid_button = this.extraParam.show_paid_button.filter(
      item => item !== ''
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        show_paid_button: this.extraParam.show_paid_button
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
      this.back()
    })
  }

  // Show Wallet App
  private addCmWalletApp() {
    this.extraParam.not_display_wallet_app.push('')
  }
  private removeCMWalletApp(index: any) {
    this.extraParam.not_display_wallet_app.splice(index, 1)
  }
  private async noWalletAppBtm() {
    // 清空未输入
    this.extraParam.not_display_wallet_app =
      this.extraParam.not_display_wallet_app.filter(item => item !== '')
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        not_display_wallet_app: this.extraParam.not_display_wallet_app
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
    })
  }

  //  Visa / MasterCard Payment
  private addCmPayment() {
    this.extraParam.not_display_visa_payment.push('')
  }
  private removeCMPayment(index: any) {
    this.extraParam.not_display_visa_payment.splice(index, 1)
  }
  private async noPaymentBtm() {
    // 清空未输入
    this.extraParam.not_display_visa_payment =
      this.extraParam.not_display_visa_payment.filter(item => item !== '')
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        not_display_visa_payment: this.extraParam.not_display_visa_payment
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
    })
  }

  // Show QR Code
  private addCmQrcode() {
    this.extraParam.not_display_qrcode.push('')
  }
  private removeCmQrcode(index: any) {
    this.extraParam.not_display_qrcode.splice(index, 1)
  }
  private async noQrcodeBtm() {
    // 清空未输入
    this.extraParam.not_display_qrcode =
      this.extraParam.not_display_qrcode.filter(item => item !== '')
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        not_display_qrcode: this.extraParam.not_display_qrcode
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
    })
  }

  // 交易方式
  private addTransitPayment() {
    this.extraParam.transit_payment.push({
      merchant_no: '',
      payment: []
    })
  }
  private removeTransitPayment(index: any) {
    this.extraParam.transit_payment.splice(index, 1)
  }
  private async noTransitPayment() {
    // 清空未输入
    this.extraParam.transit_payment = this.extraParam.transit_payment.filter(
      item => item.merchant_no !== '' && item.payment !== []
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        transit_payment: this.extraParam.transit_payment
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
    })
  }

  // 交易所
  private addTransitChoice() {
    this.extraParam.transit_choice.push({
      merchant_no: '',
      payment: []
    })
  }
  private removeTransitChoice(index: any) {
    this.extraParam.transit_choice.splice(index, 1)
  }
  private async noTransitChoice() {
    // 清空未输入
    this.extraParam.transit_choice = this.extraParam.transit_choice.filter(
      item => item.merchant_no !== '' && item.choice !== []
    )
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        transit_choice: this.extraParam.transit_choice
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
    })
  }

  private async isUpstreamTurn() {
    // 清空未输入
    this.flag = true
    const data: any = {
      id: this.product.id,
      extra_param: {
        use_upstream_api: this.extraParam.use_upstream_api
      }
    }
    await setProductInfo(data).then(() => {
      this.$message({
        message: 'Edit success',
        type: 'success'
      })
      this.flagStr()
    })
  }

  // 产品详情
  private async getInfo() {
    const data = {
      id: this.product.id
    }
    await getProductInfo(data).then((res: any) => {
      if (res) {
        this.extraParam = {
          api_key: res.extra_param.api_key,
          collect_key: res.extra_param.collect_key,
          reuse_address: res.extra_param.reuse_address,
          collect_by_stake: res.extra_param.collect_by_stake,
          show_paid_button: res.extra_param.show_paid_button,
          not_display_wallet_app: res.extra_param.not_display_wallet_app,
          not_display_visa_payment: res.extra_param.not_display_visa_payment,
          not_display_qrcode: res.extra_param.not_display_qrcode,
          not_reuse_address: res.extra_param.not_reuse_address,
          reuse_address_days: res.extra_param.reuse_address_days,
          transit_payment: res.extra_param.transit_payment,
          transit_choice: res.extra_param.transit_choice,
          use_upstream_api: res.extra_param.use_upstream_api
        }
        if (!this.extraParam.transit_payment) {
          this.extraParam.transit_payment = []
        }
        if (!this.extraParam.transit_choice) {
          this.extraParam.transit_choice = []
        }
      } else {
        this.extraParam = {
          api_key: [],
          collect_key: [],
          reuse_address: false,
          collect_by_stake: false,
          show_paid_button: [],
          not_display_wallet_app: [],
          not_display_visa_payment: [],
          not_display_qrcode: [],
          transit_payment: [],
          transit_choice: [],
          not_reuse_address: [],
          reuse_address_days: '',
          use_upstream_api: 0
        }
      }
    })
  }

  private totalPayment: any = []
  private totalChoice: any = []
  private async getData() {
    try {
      const data: any = {
        id: this.product.id
      }
      await getAccountStatistic(data).then((res: any) => {
        this.totalPayment = res.total_payment
        this.totalChoice = res.total_choice
        this.reuseAddressCount = res.reuse_address_count
      })
    } catch (e) {}
  }

  mounted() {
    this.getData()
    this.getInfo()
  }
}
